@if (showModal) {
	<app-modal [customClass]="['delivery-modal']" [title]="''">
		<div class="row">
			<div class="col-md-12 register-breadcrumb">
				<div class="items">
					<div [ngClass]="{ 'active-step': currentStep == 0 }" class="item">
						<img [src]="stepIcon(0)" alt="Pedido en análisis" loading="lazy" />
						@if ((isMobile && currentStep == 0) || !isMobile) {
							<div>Pedido en análisis</div>
						}
					</div>
					<div class="separator"></div>
					@if (contract?.type == 'DOCUMENTACIÓN') {
						<div [ngClass]="{ 'active-step': currentStep == 1 }" class="item">
							<img [src]="stepIcon(1)" alt="Documentos" loading="lazy" />
							@if ((isMobile && currentStep == 1) || !isMobile) {
								<div>Documentos pendientes</div>
							}
						</div>
					}
					@if (contract?.type !== 'DOCUMENTACIÓN') {
						<div [ngClass]="{ 'active-step': currentStep == 1 }" class="item">
							<img [src]="stepIcon(1)" alt="Firma de contrato" loading="lazy" />
							@if ((isMobile && currentStep == 1) || !isMobile) {
								<div>Firma de contrato</div>
							}
						</div>
					}
					<div class="separator"></div>
					<div [ngClass]="{ 'active-step': currentStep == 2 }" class="item">
						<img [src]="stepIcon(2)" alt="Pago" loading="lazy" />
						@if ((isMobile && currentStep == 2) || !isMobile) {
							<div>Pago</div>
						}
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<div class="pendence-content">
					<div class="order">N° de pedido: {{ contract?.contract?.rentId }}</div>
					<div class="status">
						{{ documentsTitle !== '' ? documentsTitle : contract?.contract?.status }}
					</div>
					<div class="description" [innerHTML]="documentsText !== '' ? documentsText : currentDescription"></div>
					@if (contract?.type == 'DOCUMENTACIÓN' && documents?.pendingDocuments == undefined && !documentsSuccess) {
						<ngx-skeleton-loader
							count="4"
							[theme]="{
								width: '100%',
								height: '50px',
								'margin-bottom': '10px',
								'margin-top': '10px',
							}"
							appearance="line"
						></ngx-skeleton-loader>
					}
					@if (contract?.type == 'DOCUMENTACIÓN' && documents?.pendingDocuments) {
						<div class="documents">
							@if (!documentsSuccess && !isPending) {
								@for (document of documents?.pendingDocuments; track document) {
									<app-single-uploader
										[clientType]="userType"
										[isPendence]="true"
										[preview]="true"
										[documentType]="document"
										[blobFiles]="user?.blobFiles"
										[userId]="userId"
										(selectedFile)="handleDocumentsModal($event)"
										(fileDeleted)="handleFileDeleted($event)"
										(fileUploaded)="handleFileUploaded($event)"
									></app-single-uploader>
								}
							}
						</div>
					}
					@if (contract?.type == 'DOCUMENTACIÓN' && rejectionReasonText) {
						<div class="docs-description">
							<div class="form-group invert-input">
								<label for="">Motivo de rechazo</label>
								<textarea [disabled]="true" readonly class="form-control h-100" rows="3" [value]="rejectionReasonText"></textarea>
							</div>
						</div>
					}
					@if (contract?.type !== 'ANÁLISIS') {
						<div class="actions mt-5">
							<!-- <button class="btn btn-grey" *ngIf="!signedContract && contract?.type == 'ASSINATURA'">
              proposta completa
            </button> -->
							@if (!documentsSuccess && contract?.type !== 'ASSINATURA_PJ') {
								<button class="btn btn-primary" [disabled]="(isDisabled && contract?.type == 'DOCUMENTACIÓN') || isPending" (click)="handleContinue()">
									@if (contract?.type == 'DOCUMENTACIÓN' && isPending) {
										<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
									}
									@if (contract?.type == 'DOCUMENTACIÓN') {
										{{ isPending ? 'Actualizando...' : 'Actualizar' }}
									}
									@if (contract?.type !== 'DOCUMENTACIÓN') {
										Continuar
									}
								</button>
							}
						</div>
					}
				</div>
			</div>
		</div>
	</app-modal>
}
